<template>
    <div>
        <div class="row">
            <div class="col-12">
                <div class="form-group" v-if="isAdmin">
                    <label for="library_id">{{$lang('Biblioteka')}}</label>
                    <select id="library_id" name="library_id" class="form-control" v-model="libraryID" :disabled="libraries.length < 2">
                        <option :value=0>{{$lang('wybierz')}}</option>
                        <option v-for="library in libraries" :value="library.id">{{library.name}}</option>
                    </select>
                    <input v-if="libraries.length < 2" name="library_id" :value="libraryID" hidden>
                </div>
                <input v-else name="library_id" :value="libraryID" hidden>
            </div>
        </div>

        <div class="row">
            <div class="col-12 col-md-6 form-group">
                <datepicker-accessible
                    :label-single="'Utworzone od:'"
                    custom-id="date-from"
                    name="date-from"
                    mode="date"
                    :use_pencil_checkbox="false"
                    :strong_label="false"
                    v-model="dateFrom"
                ></datepicker-accessible>
                <small class="text-red small-70" v-if="!validDate">
                    {{ $lang('Data musi być wcześniejsza niż data końcowa') }}
                </small>
            </div>

            <div class="col-12 col-md-6 form-group">
                <datepicker-accessible
                    :label-single="'Utworzone do:'"
                    custom-id="date-to"
                    name="date-to"
                    mode="date"
                    :use_pencil_checkbox="false"
                    :strong_label="false"
                    v-model="dateTo"
                ></datepicker-accessible>
                <small class="text-red small-70" v-if="!validDate">
                    {{ $lang('Data musi być późniejsza niż data początkowa') }}
                </small>
            </div>
        </div>

        <div class="row">
            <div class="col-12">
                <div class="form-group">
                    <label for="statuses">{{$lang('Statusy')}}</label>
                    <multiselect
                        :searchable=false :close-on-select=false
                        id="statuses" v-model="selected" :options="allStatuses"
                        group-values="options" group-label="label" :group-select="true"
                        :multiple="true" label="name" track-by="id"
                        :placeholder="$lang('Wybierz statusy')"
                        :selectLabel="$lang('Wybierz status')"
                        :selectedLabel="$lang('Wybrane')"
                        :deselectLabel="$lang('Usuń status')"
                        :selectGroupLabel="$lang('Wybierz wszystkie statusy')"
                        :deselectGroupLabel="$lang('Usuń wszystkie statusy')"
                    ></multiselect>

                    <input v-for="status in selected" name="statuses[]" :value="status.id" hidden>
                </div>
            </div>
        </div>

        <div class="row">
            <div class="col-12">
                <div class="form-group">
                    <label for="type">{{$lang('Typ raportu')}}</label>
                    <select class="form-control form-select" id="type" name="type" v-model="type">
                        <option v-for="item in types" :value="item">{{item}}</option>
                    </select>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import ValidDate from "../../../mixins/report-valid-date";
import DatepickerAccessible from "../../datepicker-accessible.vue";
import Multiselect from "vue-multiselect";


export default {
    name: "dora-inputs",
    components: {Multiselect, DatepickerAccessible},
    mixins: [ ValidDate],
    props: ['libraries', 'statuses', 'isAdmin'],
    data() {
        return {
            libraryID: 0,
            selected: structuredClone(this.statuses),
            allStatuses: [{
                label: 'Wszystkie',
                options: this.statuses
            }],
            type: 'Initial',
            types: ['Initial', 'Intermediate', 'Final']
        }
    },
    computed: {
        valid() {
            return this.dateFrom !== '-' && this.dateTo !== '-' && this.libraryID !== 0 && this.dateFrom<=this.dateTo;
        }
    },
    watch: {
        valid() {
            this.$emit('validation', this.valid);
        },
    },
    created() {
        const today = new Date();
        const firstDay = new Date(today.getFullYear(), today.getMonth(), 1);
        const lastDay = new Date(today.getFullYear(), today.getMonth() + 1, 0);
        this.dateFrom = firstDay.getFullYear() + '-' + ('0' + (firstDay.getMonth() + 1)).slice(-2) + '-' + ('0' + firstDay.getDate()).slice(-2);
        this.dateTo = lastDay.getFullYear() + '-' + ('0' + (lastDay.getMonth() + 1)).slice(-2) + '-' + ('0' + lastDay.getDate()).slice(-2);

        this.libraryID = this.libraries[0].id;
    }
}
</script>
